export function autocompleteSchool(selector, url) {
  window.$(selector).autocomplete(url, {
    delay: 400,
    minChars: 2,
    matchSubset: 1,
    autoFill: false,
    matchContains: 1,
    cacheLength: 10,
    selectFirst: false,
    maxItemsToShow: 10
  });
}
